exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu[data-v-8916cc96] {\n  display: flex;\n  justify-content: flex-end;\n  position: relative;\n  top: -60px;\n}\n", ""]);

// exports
